import React from "react";
import { useNavigate } from "react-router-dom";
import NoxPayLogo from './NoxPayLogo.svg';

export default function Land() {
  const navigate = useNavigate();

  const goToPOS = () => {
    navigate("/collect");
  };

  const goToMerchant = () => {
    navigate("/merchant");
  };




  return (
    <div
      style={{
        maxWidth: "420px",
        margin: "0 auto",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "20px",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
      }}
    >
      <p
        style={{
          fontSize: "14px",
          fontWeight: "600",
          color: "#9333ea",
          marginBottom: "12px",
        }}
      >
        ✨ Coming Soon... ✨
      </p>

      {/* Logo centered */}
      <div
        className="logo-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "20px",
        }}
      ></div>

<img src={NoxPayLogo} alt="NOX Logo" width={180}
  height={60}/>

 



      <h1
        style={{
          fontSize: "20px",
          fontWeight: "700",
          marginBottom: "8px",
        }}
      >
        Payment Router / DeFi Aggregator
      </h1>

      <p
        style={{
          fontSize: "12px",
          fontWeight: "400",
          color: "#6b7280",
          marginTop: "8px",
          maxWidth: "360px",
        }}
      >
        Facilitates token swaps and payments on-chain on different
        blockchain networks, enabling users to pay merchants in their preferred
        tokens while the merchant receives their desired token.
      </p>

      <button
        onClick={goToPOS}
        style={{
          padding: "14px 22px",
          fontSize: "16px",
          fontWeight: "600",
          background: "#6366f1",
          color: "white",
          border: "none",
          borderRadius: "10px",
          cursor: "pointer",
          width: "100%",
          maxWidth: "260px",
          marginTop: "20px",
        }}
      >
        Test Merchant POS
      </button>
    
    
          <button
        onClick={goToMerchant}
        style={{
          padding: "14px 22px",
          fontSize: "16px",
          fontWeight: "600",
          background: "#6366f1",
          color: "white",
          border: "none",
          borderRadius: "10px",
          cursor: "pointer",
          width: "100%",
          maxWidth: "260px",
          marginTop: "20px",
        }}
      >
        Merchant Panel
      </button>
    
    
    
    
    </div>
  );
}
